/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Channelcolmessage2Inputs */

const en_channelcolmessage2 = /** @type {(inputs: Channelcolmessage2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Message`)
};

const de_channelcolmessage2 = /** @type {(inputs: Channelcolmessage2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nachricht`)
};

/**
* | output |
* | --- |
* | "Message" |
*
* @param {Channelcolmessage2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const channelcolmessage2 = /** @type {((inputs?: Channelcolmessage2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Channelcolmessage2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_channelcolmessage2(inputs)
	return de_channelcolmessage2(inputs)
});
export { channelcolmessage2 as "channelColMessage" }